<template lang="pug">
div
  PageTitle: ModifiedDot.ml-2(:show='isModified' color='primary')
  EditManual(ref='EditManual' @done='done')
  v-card
    v-alert(type='error' :value='true' v-if='manuals === false' icon='warning') {{ $t('errorWhileLoading') }} {{ error }}
    v-alert(type='error' :value='true' v-else-if='isSaveFailed && error' icon='warning') {{ $t('failedToSave') }} {{ error }}

  v-card(:raised='isModified')
    //- 存檔工具列
    v-toolbar(flat style={ transform: `none` })
      v-spacer
      v-btn(flat icon color='primary' @click='add' :loading='!manuals'): v-icon add
    .pb-5(v-if='manuals === null')
      v-progress-linear.ma-0(:indeterminate='true')

    //- Manual列表
    v-card-text(v-if='manuals && length === 0')
      h6.grey--text 點擊右上角 + 按鈕新增項目

    v-list(two-line v-else-if='manuals')
      draggable(v-model='manuals' handle='.handle')
        transition-group(name='list')
          v-list-tile(v-for='(i, index) in manuals' @click='edit(index)' :key='i._id || i.link')
            v-list-tile-action.handle(@click.stop): v-icon(color='grey') dehaze
            v-list-tile-content
              v-list-tile-title {{ i.name }}
              v-list-tile-sub-title {{ i.link }}

            v-list-tile-action
              v-tooltip(bottom)
                v-btn.error--text(icon slot='activator' @click.stop='remove(index)'): v-icon close
                span 刪除此項目
  StickyBottomSaveContent(:loading='!manuals || isSaving' :show='isModified && manuals' :disabled='!manuals || isSaving'  @submit='submit' @cancel='discard')
  DebugCodeBlock(:value='manuals')
  SnackbarSuccess(ref='successSnackbar')
</template>

<script>
import apis from '@/assets/js/apis'

import { formStatus } from '@/mixins/formStatus'
import draggable from 'vuedraggable'
import Loader from '@/components/Loader.vue'
import ToolbarSaveContent from '@/components/ToolbarSaveContent.vue'
import StickyBottomSaveContent from '@/components/StickyBottomSaveContent.vue'
import SnackbarSuccess from '@/components/SnackbarSuccess.vue'
import PageTitle from '@/components/PageTitle.vue'
import ModifiedDot from '@/components/ModifiedDot.vue'

import EditManual from '@/components/manual/EditManual.vue'

export default {
  name: 'Manual',
  metaInfo () {
    return {
      title: this.$t('簡章'),
    }
  },
  data () {
    return {
      manuals: null,
    }
  },
  mounted () {
    this.fetch()
  },
  methods: {
    add () {
      this.$refs.EditManual.edit()
    },
    edit (index) {
      this.$refs.EditManual.edit(this.manuals[index], index)
    },
    remove (index) {
      this.manuals.splice(index, 1)
    },
    done (data, index) {
      if (index === undefined) {
        this.manuals.push(data)
      } else {
        this.$set(this.manuals, index, { ...data })
      }
    },
    async fetch () {
      const params = { key: this.userId }

      try {
        this.manuals = await apis.manuals.get(params, this.token) || null
        this.manuals = this.addIdToListItems(this.manuals)

        this.clearIsModified()
      } catch (e) {
        this.error = e.response ? e.response.data : e
        this.manuals = false
      }
    },
    async submit () {
      const body = { key: this.userId, manual: this.removeIdFromListItems(this.manuals) }
      this.isSaving = true
      this.clearError()

      try {
        await apis.manuals.put(body, this.token)
        this.$emit('success')
        this.isSaving = false
        this.$refs.successSnackbar.show('成功發佈簡章')
        this.discard()
      } catch (e) {
        this.isSaveFailed = true
        this.isSaving = false
        this.error = e.response ? e.response.data : e
      }
    },
    discard () {
      this.manuals = null
      this.clearIsModified()
      this.fetch()
    },
  },
  computed: {
    length () {
      return this.manuals ? this.manuals.length : 0
    },
  },
  watch: {
    manuals: {
      handler () {
        this.isModified = true
      },
      deep: true,
    },
  },
  components: {
    draggable,
    Loader,
    EditManual,
    ToolbarSaveContent,
    StickyBottomSaveContent,
    SnackbarSuccess,
    PageTitle,
    ModifiedDot,
  },
  mixins: [formStatus],
}
</script>

<style scoped lang="sass">
</style>
